<script>
export default {
    name: "SubHeader",
    props: {
        title: String,
    }
};
</script>

<template>
    <div class="sub-header" v-html="title"></div>
</template>

<style scoped lang="scss">

</style>